<script setup>
definePage({
  meta: {
    requiresAuth: true,
  },
});

const form = ref({});
const router = useRouter();

function onSaved() {
  router.push({ name: "contratos" });
}

function onCancel() {
  router.push({ name: "contratos" });
}
</script>

<template>
  <div>
    <VCard>
      <VCardTitle class="d-flex align-center">
        <VBtn icon variant="text" class="me-2" :to="{ name: 'contratos' }">
          <VIcon icon="tabler-arrow-left" />
        </VBtn>
        Novo Contrato de Prestador
      </VCardTitle>
      <VDivider />
      <VCardText>
        <FormContratoPrestador
          v-model="form"
          @saved="onSaved"
          @cancel="onCancel" />
      </VCardText>
    </VCard>
  </div>
</template>
